import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, TipoEnvio, SearchTipoEnvioRequest, SaveTipoEnvioDto } from "../model/index";
import { SharedFunctions } from '../../shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoEnvioService extends CrudService<TipoEnvio, number, SaveTipoEnvioDto, SearchTipoEnvioRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'TipoEnvio', sharedFunctions);

  }

  getAnonymous(encryptedId: string): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/GetList/'+encryptedId, this.httpOptions);
  }
}